import { Modal, ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceDocumentType } from '../../enums/invoiceDocumentType'
import { CancelInvoiceModalContextProvider } from './contexts/cancelInvoiceModalContext'
import { CancelInvoiceModalBody } from './elements/CancelInvoiceModalBody/CancelInvoiceModalBody'
import { CancelInvoiceModalFooter } from './elements/CancelInvoiceModalFooter/CancelInvoiceModalFooter'

interface CancelInvoiceModalProps extends ModalProps {
  documentType: InvoiceDocumentType
  invoiceId: string
  onConfirmCreditNote?: () => void
}

const CancelInvoiceModalComponent = ({
  documentType,
  id,
  invoiceId,
  onConfirmCreditNote,
  ...modalProps
}: CancelInvoiceModalProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <CancelInvoiceModalContextProvider
      documentType={documentType}
      invoiceId={invoiceId}
      modalId={id}
      onConfirmCreditNote={onConfirmCreditNote}
    >
      <Modal {...modalProps} id={id} size="s">
        <Modal.Header title={t('external_invoices.view.cancel.modal.title')} />
        <CancelInvoiceModalBody />
        <CancelInvoiceModalFooter />
      </Modal>
    </CancelInvoiceModalContextProvider>
  )
}

export const CancelInvoiceModal = withModalConditionalRender(CancelInvoiceModalComponent)
